import { SubflowMessengerAction } from 'lib-shared-types-api';

import { FlowNodeTypes } from 'components/powerFlowShared/components/types';

import { FlowMessengerNodeSubflowReturn } from '../../../flow.types';

import { isReturnNodeDescendantOfInitNode } from './isReturnNodeDescendantOfInitNode';

export function findUniqueExitPathFromSubflow(
  allActions: SubflowMessengerAction[],
): FlowMessengerNodeSubflowReturn[] {
  return allActions.filter(
    (action): action is FlowMessengerNodeSubflowReturn => {
      return (
        // First check if the action is a return node to narrow the search.
        action.nodeType === FlowNodeTypes.SUBFLOW_RETURN &&
        // Check for original exit paths and ignore the references to them.
        // When the payload.returnId and node.id are the same, the return node is an original return node and not a reused one.
        action.payload.returnId === action.id &&
        // Lastly remove the ones that not in the primary flow path.
        // We only want to consider the return nodes that are descendants of the init node for creating exit paths.
        isReturnNodeDescendantOfInitNode(action, allActions)
      );
    },
  );
}
